// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import { useLayoutEffect } from 'react';
import styled from 'styled-components';
import { useGlobalState } from './globalState/GlobalStateProvider';
import { mobileView } from './api/utility';

const Col = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    ${({ mobile }) => mobile && `width: inherit;`}
`
const OverFlow = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
`
const shadowScroll = styled.div`
    position: absolute;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 10px;
    pointer-events: none;
`
const ShadowTop = styled(shadowScroll)`
    top: 0;
    background-image: radial-gradient(farthest-side at 50% 0%, ${({ theme, mobile }) => mobile ? theme.mobile.shadow : theme.shadow} 0%, #00000000 100%);
    opacity: 0;
`
const ShadowBottom = styled(shadowScroll)`
    bottom: 0;
    background-image: radial-gradient(farthest-side at 50% 100%, ${({ theme, mobile }) => mobile ? theme.mobile.shadow : theme.shadow} 0%, #00000000 100%);
    opacity: 0;
`

const ScrollShadow = ({ children, ...props }) => {
    const { state: {
        // mobileView,
    } } = useGlobalState();

    const element = useRef(null);

    const [shadow, setShadow] = useState({
        top: {
            opacity: 0,
            height: 0
        },
        bottom: {
            opacity: 0,
            height: 0
        }
    })

    const updatePosition = () => {
        const currentPos = element.current.scrollTop;
        const elementHeight = element.current.scrollHeight - element.current.offsetHeight;
        const currentScroll = currentPos / elementHeight;
        if (!elementHeight) return
        setShadow({
            top: {
                opacity: currentScroll,
                height: currentScroll * 10 + 'px'
            },
            bottom: {
                opacity: 1 - currentScroll,
                height: Math.abs(currentScroll - 1) * 10 + 'px'
            }
        })
    }

    useLayoutEffect(() => {
        updatePosition()
    }, [])

    useEffect(() => {
        if (!element) return;
        const currentElement = element.current;
        currentElement.addEventListener('scroll', updatePosition);
        return () => currentElement.removeEventListener('scroll', updatePosition);
    })



    return (
        <Col mobile={mobileView}>
            <ShadowTop
                mobile={mobileView}
                style={{
                    opacity: shadow.top.opacity,
                    height: shadow.top.height
                }}
            />
            <OverFlow ref={element} {...props}>
                {children}
            </OverFlow>
            <ShadowBottom
                mobile={mobileView}
                style={{
                    opacity: shadow.bottom.opacity,
                    height: shadow.bottom.height
                }}
            />
        </Col>
    );
}

export default ScrollShadow;

